"use client";

import { createContext, useContext, useState, ReactNode } from "react";
import { usePathname } from "next/navigation";

type HeaderStyle = {
  transparent: boolean;
};

type HeaderContextType = {
  headerStyle: HeaderStyle;
  setHeaderStyle: React.Dispatch<React.SetStateAction<HeaderStyle>>;
};

const HeaderContext = createContext<HeaderContextType | null>(null);

type HeaderProviderProps = {
  children: ReactNode;
};

export function HeaderProvider({ children }: HeaderProviderProps) {
  const pathname = usePathname();
  const normalizedPath = pathname?.replace(/\/$/, "") || "";
  const isHomepage =
    normalizedPath === "" || /^\/[a-z]{2}$/.test(normalizedPath);

  const [headerStyle, setHeaderStyle] = useState<HeaderStyle>({
    transparent: isHomepage,
  });

  return (
    <HeaderContext.Provider value={{ headerStyle, setHeaderStyle }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeader(): HeaderContextType {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error("useHeader must be used inside HeaderProvider");
  }

  return context;
}
